module.exports = __webpack_public_path__ + "static/media/Home-YellowBlocks1.7f2a233a.svg";